import React, { Component } from 'react';
import client from './../../utils/apolloClient';
import getData from './../../data-services/api';
import { getUser } from './../../data-services/queries';
import gql from 'graphql-tag';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@material-ui/core/AppBar';
import './BirthdayInfo.css';
import noResultFoundImage from '../MyFCP/images/noResultFoundImage.png';
import Loader from './../../components/CustomLoader';
import { Table, TableRow, TableCell, TableHead, TableBody } from '@material-ui/core';

export default class BirthdayInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            FCPAll: [],
        };
    }

    async componentDidMount() {
        await client
            .query({
                query: gql(getUser),
            })
            .then(({ data }) => {
                if (data.user.role === 'CMDI' || data.user.role === 'AMMD') {
                    this.setState({
                        userData: data.user,
                    });
                }
            });

        if (this.state.userData && this.state.userData.sfid) {
            let FCPAllResult;
            if (this.state.userData.role === 'CMDI') {
                FCPAllResult = await getData(
                    `SELECT  name, email__c, Date_Of_Birth__c FROM Salesforce.Account 
                    WHERE Assigned_CMDI__c = '${this.state.userData.sfid}' and Date_Of_Birth__c notnull`
                );
            }
            if (this.state.userData.role === 'AMMD') {
                let SFID = this.state.userData.sfid;
                SFID = SFID.slice(0, -3);
                FCPAllResult = await getData(
                    `SELECT  name, email__c, Date_Of_Birth__c FROM Salesforce.Account 
                    WHERE Assigned_AMMD__c = '${SFID}' and Date_Of_Birth__c notnull `
                );
            }
            let currentMonth = new Date().getMonth() + 1;
            const FilterZone = FCPAllResult.result.filter((e) => {
                var date = e.date_of_birth__c.split('-');
                var [month] = date; // Or, var month = e.date.split('-')[1];
                return currentMonth === +month;
            });
            this.setState({
                FCPAll: FilterZone,
                loading: false,
            });
        }
    }

    render() {
        const { FCPAll, loading } = this.state;
        const { history } = this.props;

        return (
            <>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label="Menu"
                            onClick={() => {
                                history.goBack();
                            }}
                        >
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography variant="title" color="inherit">
                            Birthday Information
                        </Typography>
                    </Toolbar>
                </AppBar>
                {loading ? (
                    <Grid container alignItems="center" justify="center">
                        <Loader type="Audio" color="#00BFFF" height="50" width="50" />
                    </Grid>
                ) : (
                    <>
                        {FCPAll.length > 0 ? (
                            <div className="Birthday__OuterBox">
                                <Grid container className="Birthday__tableBox">
                                    <Table>
                                        <TableHead className="Birthday__tableHeader Birthday__Fixed">
                                            <TableRow>
                                                {/* <TableCell align="center" className='Birthday__tableHeaderTitle'> No</TableCell> */}
                                                <TableCell
                                                    align="center"
                                                    className="Birthday__tableHeaderTitle"
                                                >
                                                    {' '}
                                                    No.
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    className="Birthday__tableHeaderTitle"
                                                >
                                                    {' '}
                                                    Name{' '}
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    className="Birthday__tableHeaderTitle"
                                                >
                                                    {' '}
                                                    Date{' '}
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    className="Birthday__tableHeaderTitle"
                                                >
                                                    {' '}
                                                    Email ID{' '}
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody className="Birthday__TableBody">
                                            {FCPAll.map((row, index) => {
                                                return (
                                                    <TableRow key={row.name}>
                                                        <TableCell
                                                            align="center"
                                                            className="Birthday__tableData"
                                                        >
                                                            {index}
                                                        </TableCell>
                                                        <TableCell
                                                            align="center"
                                                            className="Birthday__tableData"
                                                        >
                                                            {row.name}
                                                        </TableCell>
                                                        <TableCell
                                                            align="center"
                                                            className="Birthday__tableData"
                                                        >
                                                            {row.date_of_birth__c
                                                                ? row.date_of_birth__c
                                                                : ' - '}
                                                        </TableCell>
                                                        <TableCell
                                                            align="center"
                                                            className="Birthday__tableData"
                                                        >
                                                            {row.email__c ? row.email__c : ' - '}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </Grid>
                            </div>
                        ) : (
                            <Grid container spacing={8} justify="center" alignItems="center">
                                <img
                                    style={{
                                        marginTop: '50px',
                                        width: 220,
                                        height: 190,
                                    }}
                                    src={noResultFoundImage}
                                    alt="img"
                                />
                            </Grid>
                        )}
                    </>
                )}
            </>
        );
    }
}
